import React, { useEffect, useState } from "react";
import {
  config,
  DOBASEURL,
  errorNotify,
  successNotify,
} from "../../utils/helper";
import { authorizedGet } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import Spinner from "../../Components/Spinner/Spinner";

const ProfileLog = ({ userId }) => {
  const [loading, setLoading] = useState(false);
  const [activityData, setActivityData] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [dates, setDates] = useState("today");
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [isApply, setIsapply] = useState(false);
  const [selecteUser, setSelectedUser] = useState("");
  let oldImages;
  let newImages;
  let maxLength;

  const fetchProfileActivityData = async (filters = {}) => {
    try {
      setLoading(true);

      const params = new URLSearchParams();
      if (userId) params.append("id", userId);
      if (filters.dateFilter) params.append("dateFilter", filters.dateFilter);
      if (filters.startDate) params.append("startDate", filters.startDate);
      if (filters.endDate) params.append("endDate", filters.endDate);

      const url = `${configuration.apis.userProfileLog}?${params.toString()}`;
      const res = await authorizedGet(url);
      const username = res?.data;
      if (username) {
        setSelectedUser(username);
        setCurrentPage(1);
      }
      const response = res?.data?.data;
      if (response) {
        setActivityData(response);
        setCurrentPage(1);
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ??
        (err?.request ? "Network error" : "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const filters = {
      dateFilter: "custom",
      startDate: today,
      endDate: today,
    };
    fetchProfileActivityData(filters);
  }, []);

  const ITEMS_PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(activityData.length / ITEMS_PER_PAGE);

  const paginatedData = activityData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  return (
    <div className="font-Poppins mx-auto w-full p-8">
      <div>
        <div className="flex h-full w-full flex-col gap-4">
          <div className="flex w-full flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="mb-4 flex items-center justify-between">
              <h1 className="md:text-1xl pl-4 text-xl font-bold">
                {selecteUser.userName}'s Profile Log
              </h1>
            </div>
            <div className="flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-3 md:w-auto">
              <select
                value={dates}
                onChange={(e) => setDates(e.target.value)}
                className="w-full cursor-pointer rounded-lg border px-3 py-2 text-sm shadow-sm outline-none sm:w-auto"
              >
                <option value="today">Today</option>
                <option value="thisWeek">This Week</option>
                <option value="thisMonth">This Month</option>
                <option value="q1">Q1 (Jan - Mar)</option>
                <option value="q2">Q2 (Apr - Jun)</option>
                <option value="q3">Q3 (Jul - Sep)</option>
                <option value="q4">Q4 (Oct - Dec)</option>
                <option value="h1">H1 (Jan - Jun)</option>
                <option value="h2">H2 (Jul - Dec)</option>
                <option value="thisYear">This Year</option>
                <option value="custom">Custom Range</option>
              </select>

              {dates === "custom" && (
                <div className="flex w-full flex-col sm:w-auto sm:flex-row sm:items-center sm:gap-2">
                  <input
                    type="date"
                    name="startDate"
                    id="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="w-full rounded border px-2 py-1 text-sm sm:w-auto"
                  />
                  <span className="text-center text-sm text-gray-600">to</span>
                  <input
                    type="date"
                    name="endDate"
                    id="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="w-full rounded border px-2 py-1 text-sm sm:w-auto"
                  />
                </div>
              )}
              <button
                className="w-full rounded-lg border bg-textYellow px-3 py-2 text-sm text-white shadow-sm outline-none sm:w-auto"
                disabled={dates === "custom" && (!startDate || !endDate)}
                onClick={() => {
                  const filters = {};
                  setIsapply(true);
                  const currentYear = new Date().getFullYear();
                
                  if (dates === "all") {
                    fetchProfileActivityData(filters);
                    return;
                  }
                
                  if (dates === "custom") {
                    if (!startDate.trim() || !endDate.trim()) {
                      errorNotify("Please select both start and end dates.");
                      return;
                    }
                    filters.dateFilter = "custom";
                    filters.startDate = startDate;
                    filters.endDate = endDate;
                  } else if (dates === "today") {
                    filters.dateFilter = "custom";
                    filters.startDate = today;
                    filters.endDate = today;
                  } 
                  else if (dates === "q1") {
                    filters.dateFilter = "custom";
                    filters.startDate = `${currentYear}-01-01`;
                    filters.endDate = `${currentYear}-03-31`;
                  } else if (dates === "q2") {
                    filters.dateFilter = "custom";
                    filters.startDate = `${currentYear}-04-01`;
                    filters.endDate = `${currentYear}-06-30`;
                  } else if (dates === "q3") {
                    filters.dateFilter = "custom";
                    filters.startDate = `${currentYear}-07-01`;
                    filters.endDate = `${currentYear}-09-30`;
                  } else if (dates === "q4") {
                    filters.dateFilter = "custom";
                    filters.startDate = `${currentYear}-10-01`;
                    filters.endDate = `${currentYear}-12-31`;
                  }
                  else if (dates === "h1") {
                    filters.dateFilter = "custom";
                    filters.startDate = `${currentYear}-01-01`;
                    filters.endDate = `${currentYear}-06-30`;
                  } else if (dates === "h2") {
                    filters.dateFilter = "custom";
                    filters.startDate = `${currentYear}-07-01`;
                    filters.endDate = `${currentYear}-12-31`;
                  } 
                  else {
                    filters.dateFilter = dates;
                  }
                
                  fetchProfileActivityData(filters);
                }}
                
              >
                Apply
              </button>
              {isApply && (
                <button
                  className="w-full rounded-lg border bg-red-700 px-3 py-2 text-sm text-white shadow-sm outline-none hover:bg-red-500 disabled:opacity-50 sm:w-auto"
                  onClick={() => {
                    setDates("today");
                    setStartDate("");
                    setEndDate("");
                    setIsapply(false);
                    fetchProfileActivityData({
                      id: userId,
                      dateFilter: "custom",
                      startDate: today,
                      endDate: today,
                    });
                  }}
                >
                  Clear Filter
                </button>
              )}
            </div>
          </div>
        </div>
        {loading ? (
          <div className="flex h-screen w-full items-center justify-center">
            <Spinner />
          </div>
        ) : paginatedData.length > 0 ? (
          <div>
            <div className="mt-5 overflow-x-auto rounded-lg bg-white shadow-md">
              <table className="w-ful divide-y divide-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                      <div className="w-40">Date & Time </div>
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                      <div className="w-40">Edited By </div>
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                      <div className="w-40">Section Name </div>
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                      <div className="w-60">Activities</div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {paginatedData.map((log, index) => (
                    <tr key={index}>
                      <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-900">
                        {new Date(log?.updatedAt).toLocaleString()}
                      </td>
                      <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-900">
                        {selecteUser.userName}
                      </td>
                      <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-900">
                        {log?.section}
                      </td>
                      <td className="px-4 py-4 text-[12px] text-gray-900">
                        <ul className="max-h-[10rem] list-inside list-disc space-y-1 overflow-y-auto pr-2">
                          {Object.entries(log.changes).map(
                            ([key, value], i) => (
                              <li key={i}>
                                <strong>{key}</strong> :&nbsp;
                                {key === "images" ? (
                                  ((oldImages = Array.isArray(value.old)
                                    ? value.old
                                    : [value.old]),
                                  (newImages = Array.isArray(value.new)
                                    ? value.new
                                    : [value.new]),
                                  (maxLength = Math.max(
                                    oldImages.length,
                                    newImages.length,
                                  )),
                                  (
                                    <div className="space-y-3 pl-3">
                                      {Array.from({ length: maxLength }).map(
                                        (_, idx) => {
                                          const oldUrl = oldImages[idx];
                                          const newUrl = newImages[idx];

                                          if (oldUrl !== newUrl) {
                                            return (
                                              <div
                                                key={idx}
                                                className="flex items-center gap-4"
                                              >
                                                <div className="flex flex-col items-center">
                                                  {oldUrl ? (
                                                    <img
                                                      src={DOBASEURL + oldUrl}
                                                      alt={`Old ${idx}`}
                                                      className="h-10 w-10 rounded-full border object-cover"
                                                    />
                                                  ) : (
                                                    <span className="text-xs text-gray-400">
                                                      No previous image
                                                    </span>
                                                  )}
                                                </div>

                                                <span className="text-sm text-gray-500">
                                                  &rarr;
                                                </span>

                                                <div className="flex flex-col items-center">
                                                  {newUrl ? (
                                                    <img
                                                      src={DOBASEURL + newUrl}
                                                      alt={`New ${idx}`}
                                                      className="h-10 w-10 rounded-full border object-cover"
                                                    />
                                                  ) : (
                                                    <span className="text-xs text-gray-400">
                                                      Image removed
                                                    </span>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          }

                                          return null;
                                        },
                                      )}
                                    </div>
                                  ))
                                ) : (
                                  <>
                                    <span className="text-red-600">
                                      "
                                      {Array.isArray(value?.old)
                                        ? value?.old?.join(", ")
                                        : String(value?.old)}
                                      "
                                    </span>
                                    &nbsp;&rarr;&nbsp;
                                    <span className="text-green-600">
                                      "
                                      {Array.isArray(value?.new)
                                        ? value?.new?.join(", ")
                                        : String(value?.new)}
                                      "
                                    </span>
                                  </>
                                )}
                              </li>
                            ),
                          )}
                        </ul>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="mt-6 flex items-center justify-center space-x-2">
              <button
                className="rounded bg-gray-200 px-3 py-1 hover:bg-gray-300 disabled:opacity-50"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              >
                Previous
              </button>
              <span className="text-sm">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="rounded bg-gray-200 px-3 py-1 hover:bg-gray-300 disabled:opacity-50"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              >
                Next
              </button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center p-10">
            <h4 className="text-black">No Admin Profilelog data available.</h4>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileLog;
